import { StrictMode } from 'react';
import { createRoot, type Root } from 'react-dom/client';

import { App } from './App';

/** Attach the app to a DOM container and hand back the React root. */
export function mountApp(container: Element | DocumentFragment): Root {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  return root;
}
